import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const scrollToHash = () => {
        const target = document.getElementById(hash.slice(1));
        if (target) {
          target.scrollIntoView();
          return;
        }
        window.scrollTo(0, 0);
      };

      const timeoutId = window.setTimeout(scrollToHash, 0);
      return () => window.clearTimeout(timeoutId);
    }

    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
}
